import React, { useState } from 'react';

export default function EmailCheckbox({ label, onEmailChange }) {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        const newChecked = !isChecked;
        setIsChecked(newChecked);
        if (!newChecked) {
            onEmailChange && onEmailChange('');
        }
    };

    return (
        <div className="d-flex flex-column w-100">
            <label className="custom-checkbox d-flex align-items-center px-2" style={{paddingTop: '20px', paddingBottom: '20px'}}>
                <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange}/>
                <span className="custom-checkbox__checkmark"/>
                <span className='custom-checkbox_label'>{label}</span>
            </label>

            {isChecked && (
                <div className="d-flex align-items-center px-2">
                    <input
                        type="email"
                        defaultValue=""
                        onChange={(e) => onEmailChange && onEmailChange(e.target.value)}
                        placeholder="Введите email"
                        className={'w-100 border-0 background_pastel_grey'}
                        style={{
                            padding: '10px 16px 10px 16px',
                            borderRadius: '12px',
                            height: '52px',
                            width: '65px',
                            outline: 'none',
                        }}
                    />
                </div>
            )}
        </div>
    );
}
